export const SITE = {
  name: 'YOMO SHOP',
  slogan: '소소한 제품일지라도, 큰 만족을 드립니다.',
  description:
    '제조사와 차종으로 내 차에 맞는 충전구 커버·충전포트 플랩·수납 용품을 찾는 요모컴퍼니 공식 자사몰',
  legalName: '요모컴퍼니',
  ceo: '허홍',
  businessNumber: '137-51-00852',
  smartstoreName: '네이버 스마트스토어 요모샵',
  smartstoreUrl: 'https://smartstore.naver.com/yomoshop',
  phone: null as string | null,
  email: null as string | null,
  address: null as string | null,
  mailOrderNumber: null as string | null,
} as const

export const SHOP_POLICY = {
  shippingFee: 2750,
  remoteAreaFee: 3000,
  carrier: '로젠택배',
  dispatchNote:
    '주문 확인 후 제작하며, 결제 완료 후 영업일 2일 이내 발송합니다.',
  returnFee: 3500,
  exchangeFee: 7000,
  returnCarrier: '한진택배',
  returnAddress: '서울특별시 송파구 마천로 129-4 401호 (우 05724)',
  returnWindowDays: 7,
  cartMaxQuantity: 20,
  cartMaxLines: 30,
} as const

export function formatWon(value: number) {
  return `${value.toLocaleString('ko-KR')}원`
}
